import { Directive, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({ selector: '[customTooltip]', providers: [MatTooltip] })

export class CustomTooltipDirective {
  @Input() customTooltip: string = '';

  constructor(private tooltip: MatTooltip) { }

  @HostListener('mouseover') mouseover() {
    this.tooltip.tooltipClass = 'tooltip';
    this.tooltip.message = this.customTooltip;
    this.tooltip.show();
  }

  @HostListener('mouseleave') mouseleave() {
    this.tooltip.hide();
  }

}